// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1z7-L","form":"styles_form__3ePCF"};